import type React from 'react';
import { PageTitle } from '@/hooks/usePageTitle';

// When the terms text last changed. Update this whenever the wording below changes.
const LAST_UPDATED = 'July 31, 2026';

const Terms: React.FC = () => (
  <div className="mx-auto max-w-3xl px-4 sm:px-8 page-top">
    <PageTitle title="Terms of service" />
    <h1 className="font-display text-3xl font-bold tracking-tight text-grey-900 mb-6">Terms of Service</h1>
    <div className="prose prose-grey max-w-none">
      <p className="text-muted-foreground">
        Last updated: {LAST_UPDATED}
      </p>
      <p className="mt-4">
        Welcome to Showliner, a product of Swavely Creative Co. By accessing or using our services,
        you agree to be bound by these Terms of Service.
      </p>
      <h2 className="font-heading text-xl font-semibold mt-8 mb-3">Use of Service</h2>
      <p>
        You must be at least 13 years old to use the Service. You are responsible for maintaining the
        security of your account credentials and for all activities that occur under your account.
      </p>
      <h2 className="font-heading text-xl font-semibold mt-8 mb-3">Content</h2>
      <p>
        You retain ownership of content you create on the platform. By posting content, you grant
        Showliner a non-exclusive license to display it as part of the Service.
      </p>
    </div>
  </div>
);

export default Terms;
